import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function GestaoFiscal() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Gestão Fiscal - N&N Soluções Empresariais | Planejamento Tributário em Goiânia';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Gestão fiscal especializada em Goiânia. Soluções para minimizar impostos e manter uma vida financeira saudável com planejamento tributário eficiente.');
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Gestão Fiscal",
      "description": "Soluções para minimizar impostos e manter uma vida financeira saudável",
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/servicos/gestao-fiscal`,
      "provider": {
        "@type": "Organization",
        "name": "N&N Soluções Empresariais",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Av. Goiás, 606",
          "addressLocality": "Goiânia",
          "addressRegion": "GO",
          "postalCode": "74015-010",
          "addressCountry": "BR"
        }
      },
      "areaServed": "Goiânia",
      "serviceType": "Planejamento Tributário"
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.text.includes('Gestão Fiscal')) {
          script.remove();
        }
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header/Navigation */}
      <header className="bg-white shadow-sm fixed w-full top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/3e6f8fcc8f2630e876a6bece5f75fd5d/1e6fcf1846e59e804b7269319d1935e6.png" 
                alt="N&N Soluções Empresariais" 
                className="h-16 w-auto cursor-pointer"
                onClick={() => navigate('/')}
              />
            </div>
            <nav className="hidden md:flex space-x-8">
              <button onClick={() => navigate('/')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Home</button>
              <button onClick={() => navigate('/servicos')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Serviços</button>
              <button onClick={() => navigate('/sobre')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Sobre</button>
              <button onClick={() => navigate('/contato')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Contato</button>
              <button onClick={() => navigate('/agendamento')} className="text-gray-700 transition-colors cursor-pointer" style={{ color: '#72142B' }}>Agendamento</button>
            </nav>
            <a 
              href="https://wa.me/5562993911090"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white px-6 py-2 rounded-full hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#72142B' }}
            >
              Fale Conosco
            </a>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-4">
              <li>
                <button onClick={() => navigate('/')} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-gray-400"></i>
              </li>
              <li>
                <button onClick={() => navigate('/servicos')} className="text-gray-500 hover:text-gray-700 cursor-pointer">
                  Serviços
                </button>
              </li>
              <li>
                <i className="ri-arrow-right-s-line text-gray-400"></i>
              </li>
              <li>
                <span className="font-medium" style={{ color: '#72142B' }}>Gestão Fiscal</span>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Hero Section */}
      <section 
        className="relative py-32 overflow-hidden"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20tax%20planning%20office%20with%20financial%20documents%20and%20tax%20forms%20on%20organized%20desk%2C%20calculator%20showing%20tax%20calculations%2C%20computer%20displaying%20tax%20software%20interface%2C%20warm%20professional%20lighting%20creating%20trustworthy%20environment%20for%20fiscal%20management%20services&width=1920&height=800&seq=gestao-fiscal-hero&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#72142B]/80 via-[#72142B]/40 to-transparent"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              Gestão Fiscal
            </h1>
            <p className="text-xl text-white/90 mb-8">
              Soluções para minimizar impostos e manter uma vida financeira saudável através de planejamento tributário eficiente.
            </p>
            <a 
              href="https://wa.me/5562993911090"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 hover:transform hover:scale-105 whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#FAF7F2', color: '#72142B' }}
            >
              Solicitar Orçamento
            </a>
          </div>
        </div>
      </section>

      {/* Serviço Detalhado */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6" style={{ color: '#72142B' }}>
                Planejamento Tributário Inteligente
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Nossa gestão fiscal vai além do cumprimento de obrigações. Desenvolvemos estratégias personalizadas para reduzir a carga tributária da sua empresa de forma legal e eficiente, garantindo mais recursos para investir no crescimento do seu negócio.
              </p>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1" style={{ backgroundColor: '#72142B' }}>
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2" style={{ color: '#72142B' }}>Economia Tributária</h3>
                    <p className="text-gray-600">Identificamos oportunidades legais para reduzir impostos</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1" style={{ backgroundColor: '#72142B' }}>
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2" style={{ color: '#72142B' }}>Compliance Total</h3>
                    <p className="text-gray-600">Garantimos o cumprimento de todas as obrigações fiscais</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center mr-4 mt-1" style={{ backgroundColor: '#72142B' }}>
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2" style={{ color: '#72142B' }}>Monitoramento Contínuo</h3>
                    <p className="text-gray-600">Acompanhamos mudanças na legislação tributária</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20tax%20consultant%20analyzing%20financial%20documents%20and%20tax%20forms%20in%20modern%20office%2C%20calculator%20and%20computer%20showing%20tax%20planning%20software%2C%20organized%20workspace%20conveying%20expertise%20in%20fiscal%20management%20and%20tax%20optimization%20strategies&width=600&height=500&seq=gestao-fiscal-detail&orientation=landscape"
                alt="Gestão Fiscal Profissional"
                className="w-full h-auto rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Serviços Inclusos */}
      <section className="py-20" style={{ backgroundColor: '#FAF7F2' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4" style={{ color: '#72142B' }}>
              Nossos Serviços Fiscais
            </h2>
            <p className="text-xl text-gray-600">Soluções completas para otimização tributária</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-calculator-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Planejamento Tributário</h3>
              <p className="text-gray-600">Estratégias para reduzir legalmente a carga tributária</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-file-list-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Obrigações Acessórias</h3>
              <p className="text-gray-600">Entrega de todas as declarações e informações fiscais</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-search-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Revisão Fiscal</h3>
              <p className="text-gray-600">Análise de tributos pagos e recuperação de valores</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-shield-check-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Defesa Fiscal</h3>
              <p className="text-gray-600">Representação em processos administrativos fiscais</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-exchange-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Mudança de Regime</h3>
              <p className="text-gray-600">Análise e migração para regime tributário mais vantajoso</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: '#72142B' }}>
                <i className="ri-alert-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-3" style={{ color: '#72142B' }}>Monitoramento Legal</h3>
              <p className="text-gray-600">Acompanhamento de mudanças na legislação tributária</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section 
        className="py-20"
        style={{
          background: `linear-gradient(135deg, #72142B 0%, #8B1538 50%, #72142B 100%)`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Reduza seus impostos legalmente
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
            Descubra como nosso planejamento tributário pode economizar milhares de reais em impostos para sua empresa
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/5562993911090"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-8 py-4 rounded-full hover:opacity-90 transition-all duration-300 whitespace-nowrap cursor-pointer text-lg font-semibold"
              style={{ backgroundColor: '#FAF7F2', color: '#72142B' }}
            >
              Solicitar Análise Gratuita
            </a>
            <button 
              onClick={() => navigate('/agendamento')}
              className="border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer text-lg font-semibold"
              style={{ borderColor: '#FAF7F2', color: '#FAF7F2' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#FAF7F2';
                e.currentTarget.style.color = '#72142B';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#FAF7F2';
              }}
            >
              Agendar Consulta
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="text-white py-16" style={{ backgroundColor: '#72142B' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="col-span-1 md:col-span-2">
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                N&N Soluções Empresariais
              </h3>
              <p className="text-white/80 mb-6">
                Simplificando sua contabilidade para você focar no que realmente importa.
              </p>
              <div className="space-y-2">
                <p className="flex items-center text-gray-300">
                  <i className="ri-phone-line mr-3"></i>
                  WhatsApp: (62) 99391-1090
                </p>
                <p className="flex items-center text-gray-300">
                  <i className="ri-mail-line mr-3"></i>
                  contato@nnsolucoes.com.br
                </p>
                <p className="flex items-center text-gray-300">
                  <i className="ri-map-pin-line mr-3"></i>
                  Av. Goiás, 606 - Setor Central, Goiânia - GO
                </p>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Links Úteis</h4>
              <ul className="space-y-2">
                <li><button onClick={() => navigate('/')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Home</button></li>
                <li><button onClick={() => navigate('/servicos')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Serviços</button></li>
                <li><button onClick={() => navigate('/sobre')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Sobre</button></li>
                <li><button onClick={() => navigate('/contato')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Contato</button></li>
                <li><button onClick={() => navigate('/agendamento')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Agendamento</button></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Nossos Serviços</h4>
              <ul className="space-y-2">
                <li><button onClick={() => navigate('/servicos/gestao-contabil')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Gestão Contábil</button></li>
                <li><button onClick={() => navigate('/servicos/gestao-fiscal')} className="text-white/80 hover:text-white transition-colors cursor-pointer">Gestão Fiscal</button></li>
                <li><span className="text-white/80">Relatórios Financeiros</span></li>
                <li><span className="text-white/80">Gestão de Pessoas</span></li>
                <li><span className="text-white/80">Consultoria Empresarial</span></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/20 mt-12 pt-8 text-center">
            <p className="text-white/80">
              © 2024 N&N Soluções Empresariais. Todos os direitos reservados. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white ml-1 cursor-pointer" style={{ color: '#FAEBEA' }}>
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
